import {Component, OnDestroy, OnInit} from '@angular/core';
import {BookingHeaderTitleServiceService} from '../booking-header/booking-header-title-service.service';
import {ActivatedRoute} from '@angular/router';
import {ApiService} from '../api.service';
import {NgxSpinnerService} from 'ngx-spinner';
import {DomSanitizer} from '@angular/platform-browser';
import {ReferralDetails} from '../_model/referral-details';
import {formatNumber} from '../_helpers/telephone_helper';
import {ApplicationSettingsService} from '../application-settings.service';
import {UntypedFormBuilder, UntypedFormGroup, Validators} from '@angular/forms';
import {getFormValidationErrors} from '../_helpers/debug_helper';
import {CreateReferralRequest} from '../_model/create-referral-request';
import {Subject} from 'rxjs';
import {Venue} from '../_model/venue';
import {Program} from '../_model/program';

@Component({
  selector: 'app-referral',
  templateUrl: './referral.component.html',
  styleUrls: ['./referral.component.css']
})
export class ReferralComponent implements OnInit, OnDestroy {

  referralForm: UntypedFormGroup;

  referralDetails: ReferralDetails;
  venues: Venue[] = [];
  programs: Program[] = [];
  loading = true;
  image: any = null;
  referralFormSubmitted = false;
  referralComplete = false;

  countryCode: string;
  runningUpdate = false;

  ngUnsubscribe: Subject<void> = new Subject<void>();

  constructor(private titleService: BookingHeaderTitleServiceService,
              private route: ActivatedRoute,
              private spinner: NgxSpinnerService,
              private sanitizer: DomSanitizer,
              private formBuilder: UntypedFormBuilder,
              private applicationSettings: ApplicationSettingsService,
              private apiService: ApiService) { }

  ngOnInit(): void {
    this.titleService.setTitle('Refer a Friend');

    this.spinner.show();

    this.countryCode = this.applicationSettings.countryCode;

    this.referralForm = this.formBuilder.group({
      titleSelect: ['', Validators.required],
      givenNameInput: ['', Validators.required],
      familyNameInput: ['', Validators.required],
      emailInput: ['', [Validators.required,
        Validators.pattern('^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$')
      ]],
      telephoneHomeInput: [''],
      venueSelect: ['', Validators.required],
      programSelect: ['', Validators.required],
      notesTextArea: ['']
    });

    this.route.params.subscribe(params => {
      this.apiService.getReferralDetails(params.code, this.ngUnsubscribe).subscribe(response => {
        this.referralDetails = response;

        if (response.hasHeaderImage) {
          this.apiService.getReferralCampaignHeaderImage(response.referralCampaignId, this.ngUnsubscribe).subscribe(blob => {
            let objectURL = URL.createObjectURL(blob);
            this.image = this.sanitizer.bypassSecurityTrustUrl(objectURL);

            this.loading = false;
            this.spinner.hide();
          });
        } else {
          this.loading = false;
          this.spinner.hide();
        }

        this.apiService.registerReferralOpen(params.code).subscribe(() => {});
      });

      this.apiService.getVenues(this.ngUnsubscribe).subscribe(venues => {
        this.venues = venues;
      });

      this.apiService.getPrograms(null, null, this.ngUnsubscribe).subscribe((data) => {
        this.programs = data;

        if (this.programs.length === 1) {
          this.referralForm.get('program').setValue(this.programs[0].id);
        }
      });
    });
  }

  ngOnDestroy(): void {
    // This aborts all HTTP requests.
    this.ngUnsubscribe.next();
    // This completes the subject properly.
    this.ngUnsubscribe.complete();
  }

  onReferralFormSubmit(): void {
    this.referralFormSubmitted = true;

    if (this.runningUpdate || this.referralForm.invalid) {
      getFormValidationErrors(this.referralForm);
      return;
    }

    this.runningUpdate = true;

    const request = new CreateReferralRequest();
    request.title = this.referralForm.get('titleSelect').value;
    request.givenName = this.referralForm.get('givenNameInput').value;
    request.familyName = this.referralForm.get('familyNameInput').value;
    request.email = this.referralForm.get('emailInput').value;
    request.telephone = this.referralForm.get('telephoneHomeInput').value;
    request.venues = [];
    request.venues.push(this.referralForm.get('venueSelect').value)
    request.programme = this.referralForm.get('programSelect').value;
    request.notes = this.referralForm.get('notesTextArea').value;

    this.apiService.createReferral(this.referralDetails.code, request, this.ngUnsubscribe).subscribe(() => {
      this.referralComplete = true;
    }, (error => {
      console.error('Failed to create referral', error);
      this.runningUpdate = false;
    }));
  }

  formatTelephone() {
    this.referralForm.get('telephoneHomeInput').setValue(formatNumber(this.referralForm.get('telephoneHomeInput').value, this.countryCode));
  }
}
